import { applyMiddleware, compose, createStore } from 'redux'

import { featureFlagMiddleware } from './middleware'
import rootReducer from './reducers'

const initStore = () => {
  const windowGlobal = typeof window !== 'undefined' && window

  const devTools = process.env.NODE_ENV === 'development'
    && windowGlobal.devToolsExtension
    // eslint-disable-next-line
    ? windowGlobal.__REDUX_DEVTOOLS_EXTENSION__
      // eslint-disable-next-line no-underscore-dangle
      && window.__REDUX_DEVTOOLS_EXTENSION__()
    : (f) => f

  const store = createStore(
    rootReducer,
    compose(applyMiddleware(featureFlagMiddleware), devTools),
  )

  return store
}

export default initStore
